import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLockClosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.5 15.25C10.0858 15.25 9.75 15.5858 9.75 16C9.75 16.4142 10.0858 16.75 10.5 16.75H13.5C13.9142 16.75 14.25 16.4142 14.25 16C14.25 15.5858 13.9142 15.25 13.5 15.25H10.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.25 8.02439V10.325C4.53832 10.6725 3.25 12.1858 3.25 14V18C3.25 20.0711 4.92893 21.75 7 21.75H17C19.0711 21.75 20.75 20.0711 20.75 18V14C20.75 12.1858 19.4617 10.6725 17.75 10.325V8.02439C17.75 4.84289 15.1749 2.25 12 2.25C8.82506 2.25 6.25 4.84289 6.25 8.02439ZM12 3.75C9.66037 3.75 7.75 5.66443 7.75 8.02439V10.25H16.25V8.02439C16.25 5.66443 14.3396 3.75 12 3.75ZM4.75 14C4.75 12.7574 5.75736 11.75 7 11.75H17C18.2426 11.75 19.25 12.7574 19.25 14V18C19.25 19.2426 18.2426 20.25 17 20.25H7C5.75736 20.25 4.75 19.2426 4.75 18V14Z",
		fill: "currentColor"
	})]
});
export { SvgIconLockClosed as ReactComponent };
